import React from "react";

const ManageAmbulanceList = () => {
  return <div>ManageAmbulanceList</div>;
};

export default ManageAmbulanceList;
